import Vuex from 'vuex'
import camelCase from 'xe-utils/camelCase'
import getters from '@/store/getters'
/**
 * loadStoreModules
 * @returns
 */
function loadStoreModules() {
  // https://webpack.js.org/guides/dependency-management/#requirecontext
  const modulesFiles = require.context('./modules', true, /\.js$/)
  // you do not need `import app from './modules/app'`
  // it will auto require all vuex module from modules file
  return modulesFiles.keys().reduce((module, modulePath) => {
    // set './app.js' => 'app'
    const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
    const value = modulesFiles(modulePath)
    module[camelCase(moduleName).replace('Store', '')] = value.default
    return module
  }, {})
}

let store = null

export function registerStore(app) {
  app.use(Vuex)
  // Enable strict mode when not in production mode
  store = new Vuex.Store({
    modules: loadStoreModules(),
    getters
  })
  app.merge({ store })
  return store
}
export function useStore() {
  return store
}
